import { FC } from 'react'

import { LoadingSpinner } from '@/components'
import { IconButton } from '@/compositions'
import { User } from '@/entities/User/User'
import { trans } from '@/helpers/trans'

import './WelcomeRegistration.scss'

interface WelcomeRegistrationProps {
    isLoading: boolean
    currentUser?: User
    onNextStep: () => void
    className?: string
}

export const WelcomeRegistration: FC<WelcomeRegistrationProps> = ({
    isLoading,
    currentUser,
    onNextStep,
    className = '',
}) => {
    const hasError = ! isLoading && ! currentUser

    return (
        <div className={`welcome-registration ${className}`}>
            <h4 className="welcome-registration__title">{trans('pages.registration.introTitle')}</h4>
            <div className="welcome-registration__modal-body">
                <p className="welcome-registration__intro">
                    {hasError ? trans('pages.registration.registrationError') : trans('pages.registration.intro')}
                </p>
                {isLoading && <LoadingSpinner className="welcome-registration__loading-spinner" />}
                {currentUser && (
                    <IconButton
                        icon="chevron-right"
                        iconPos="right"
                        text={trans('pages.registration.dataCheck')}
                        onClick={onNextStep}
                        className="welcome-registration__button"
                    />
                )}
            </div>
        </div>
    )
}
